// src/components/Footer.js

import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'; // Import the CSS file for styling
import { Facebook, Instagram, Twitter, YouTube, WhatsApp  } from '@mui/icons-material';
import { Box, Typography, IconButton, useMediaQuery } from '@mui/material';

const Footer = () => {
      const isMobile = useMediaQuery('(max-width:768px)');
    
  return (
    <footer className="footer" id="footer">
      <div className="footer-container">
        <div className="footer-row">
          <div className="footer-col">
            <h4>FoodSakz </h4>

                <img
            src={"../images/foodsakzsidegraylogo.png"}
            alt="Logo"
            width={175}
            height={60}
            style={{
              marginBottom: 20,
            }}
          />
          <p></p>
          </div>
          <div className="footer-col">
            <h4>Company</h4>
            <ul>
              <li><Link to="/aboutus#vision">About Us</Link></li>
              <li><Link to="/aboutus#vision">Vision</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Policies</h4>
            <ul>
              <li><Link to="/privacypolicy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms and Conditions</Link></li>
              <li><Link to="/refund">Return & Refund Terms</Link></li>
              <li><Link to="/shipping">Delivery & Shipping Policy</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Dowload App</h4>
            <ul>
              <li><Link to="https://play.google.com/store/apps/details?id=com.foodsakz.app">FoodSakz Android App</Link></li>
              <li><Link to="/">FoodSakz IOS App(Coming Soon)</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-row">
          <div className="footer-col">
            <h4>Help and Contact</h4>
            <ul>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
                
{!isMobile && (
  <>
              <li><Link to="/supplierlogin">Supplier Login</Link></li>
              <li><Link to="/shipperlogin">Shipper Login</Link></li>
 </>
 )}
            </ul>
          </div>
          <div className="footer-col">
            <h4>Our Support</h4>
            <dl>
              <dt>Support</dt>
              <dd><a href="mailto:support@foodsakz.com">support@foodsakz.com</a></dd>
              <dt>Directors</dt>
              <dd><a href="mailto:info@foodsakz.com">info@foodsakz.com</a></dd>
            </dl>
          </div>
          <div className="footer-col">
            <h4>Stay Connected</h4>
            <div className="social-links">
    
     <IconButton color="inherit" component="a"
    href="https://www.facebook.com/profile.php?id=61582746269846"
    target="_blank"><Facebook /></IconButton>
        <IconButton color="inherit" component="a"
    href="https://www.instagram.com/foodsakz/"
    target="_blank"><Instagram /></IconButton>
        <IconButton color="inherit" component="a"
    href="https://x.com/foodsakz"
    target="_blank"><Twitter /></IconButton>
        <IconButton color="inherit" component="a"
    href="https://www.youtube.com/@Foodsakz"
    target="_blank"><YouTube /></IconButton>
        <IconButton color="inherit" component="a"
    href="https://wa.me/message/UCWLVVPCYBD6J1"
    target="_blank"><WhatsApp /></IconButton>
            </div>
          </div>
        </div>
        <div className="footer-row">
       <p>© {new Date().getFullYear()} FoodSakz Online Grocery Shop. All rights reserved</p>
          <p>Powered By IGermiTech Corporation</p>
         
        </div>
      </div>
    </footer>
  );
};

export default Footer;
